import { PAYMENTS } from "@/data/payments";

export default function PaymentStrip({ title, sub }) {
  return (
    <div data-testid="payment-strip" className="w-full">
      {(title || sub) && (
        <div className="mb-5">
          {title && (
            <h4 className="font-display text-xl tracking-wider text-orange-300">
              {title}
            </h4>
          )}
          {sub && <p className="mt-1.5 text-xs text-zinc-500 max-w-md">{sub}</p>}
        </div>
      )}
      <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-2.5">
        {PAYMENTS.map((p) => (
          <PaymentTile key={p.id} item={p} />
        ))}
      </div>
    </div>
  );
}

function PaymentTile({ item }) {
  return (
    <div
      data-testid={`payment-${item.id}`}
      title={item.name}
      style={{ background: item.bg }}
      className="group relative h-14 rounded-xl ring-1 ring-orange-500/20 hover:ring-orange-500/60 hover:scale-[1.03] transition-all flex items-center justify-center px-3 overflow-hidden shadow-sm"
    >
      <span
        className="font-display tracking-wider text-base sm:text-lg leading-none whitespace-nowrap"
        style={{ color: item.fg }}
      >
        {item.short}
      </span>
      <div
        className="absolute bottom-0 left-0 h-0.5 w-full"
        style={{ background: item.accent, opacity: 0.7 }}
      />
    </div>
  );
}
